<template>
  <div class="mydialog big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="container">
      <div>
        <div class="box">
          <div class="searchbox">
            <div class="item">
              <span>患者姓名</span>
              <el-input
                v-model="patient_name"
                style="width: 110px; margin-left: 5px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生姓名</span>
              <el-input
                v-model="doctor_name"
                style="width: 110px; margin-left: 5px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>医生手机号</span>
              <el-input
                v-model="doctor_phone"
                style="width: 110px; margin-left: 5px"
                @input="search"
                clearable
              ></el-input>
            </div>
            <div class="item">
              <span>接诊时间</span>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width: 225px; margin-left: 5px"
                @change="search"
              >
              </el-date-picker>
            </div>
            <div class="item">
              <span>问诊类型</span>
              <el-select
                v-model="consult_type"
                placeholder="请选择"
                style="width: 170px; margin-left: 5px"
                @change="search"
              >
                <el-option
                  label="全部"
                  value="0"
                ></el-option>
                <el-option
                  label="患者问诊"
                  value="1"
                ></el-option>
                <el-option
                  label="医生赠送"
                  value="2"
                ></el-option>
                <el-option
                  label="诊后咨询"
                  value="3"
                ></el-option>
                <el-option
                  label="视频问诊"
                  value="4"
                ></el-option>
                <el-option
                  label="电话问诊"
                  value="5"
                ></el-option>
              </el-select>
              <el-button
                type="info"
                style="
                  background-color: #eceff2;
                  color: #747981;
                  margin-left: 20px;
                "
                @click="search"
              >查询</el-button>
            </div>
            <div class="item">
              <span>是否测试医生</span>
              <el-radio-group
                v-model="is_test"
                @change="search"
                style="margin-left: 5px"
              >
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>
          </div>

          <div style="border: solid 1px #c9cbd6">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%; min-width: 1000px"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column label="接诊时间">
                <template slot-scope="scope">
                  <div>{{ scope.row.submit_time }}</div>
                  <div>{{ scope.row.agree_time }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="问诊费用"
                prop="pay_money"
              ></el-table-column>
              <el-table-column label="患者信息">
                <template slot-scope="scope">
                  <div>{{ scope.row.real_name }}</div>
                  <div>
                    <span v-if="scope.row.patient_sex == 1">男</span>
                    <span v-if="scope.row.patient_sex == 2">女</span>
                    <span v-if="scope.row.patient_sex == 0">未知</span>
                    <span style="margin-left: 10px">{{ scope.row.age }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="科室"
                prop="department_name"
              ></el-table-column>

              <el-table-column label="医生信息">
                <template slot-scope="scope">
                  <div
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer"
                  >{{ scope.row.doctor_name }}</div>
                  <div>
                    <span v-if="scope.row.doctor_sex == 1">男</span>
                    <span v-if="scope.row.doctor_sex == 2">女</span>
                    <span v-if="!scope.row.doctor_sex">未知</span>
                    <span style="margin-left: 10px">{{ scope.row.title }}</span>
                  </div>
                  <div>{{ scope.row.phone }}</div>
                </template>
              </el-table-column>
              <el-table-column label="问诊类型">
                <template slot-scope="scope">
                  <span v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 1
                    ">患者问诊</span>
                  <span v-if="scope.row.consult_type == 2">医生赠送</span>
                  <span v-if="scope.row.consult_type == 3">诊后咨询</span>
                  <span v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 2
                    ">视频问诊</span>
                  <span v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 3
                    ">电话问诊</span>
                </template>
              </el-table-column>
              <el-table-column
                label="结束时间"
                prop="over_time"
                width="150px"
              ></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="
                      toDetail(scope.row.consult_id, scope.row.consult_types)
                    "
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('50')
                        : false
                    "
                  >查看记录</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalNum"
              style="margin:20px 0"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from '../../../api/platform';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      patient_name: '',
      doctor_name: '',
      doctor_phone: '',
      consult_type: '0',
      date: [],
      proList: [],
      options: [
        {
          value: 8,
          label: '超时未发起'
        },
        {
          value: 4,
          label: '医生拒绝'
        },
        {
          value: 6,
          label: '超时未接诊'
        },
        {
          value: 5,
          label: '问诊时间结束'
        },
        {
          value: 7,
          label: '手动结束'
        },
        {
          value: 9,
          label: '医生退款'
        }
      ],
      value: [],
      is_test: 2,
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        patient_name: this.patient_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        consult_status: 2,
        over_type: this.value.length ? this.value.toString() : '0',
        is_test: this.is_test,
        consult_type: this.consult_type,
        province_id: this.province_id
      };
      if (this.date && this.date.length > 0) {
        data.over_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.over_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/Consult/consultListMonitor', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.submit_time = item.submit_time
                ? platform.timestampToTime(item.submit_time)
                : '---------';
              item.agree_time = item.agree_time
                ? platform.timestampToTime(item.agree_time)
                : '---------';
              item.over_time = item.over_time
                ? platform.timestampToTime(item.over_time)
                : '';
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    toDetail(consult_id, consult_types) {
      this.$router.push({
        path: 'treatmentdetail',
        query: {
          consult_id,
          consult_types
        }
      });
    }
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 20px 0;
  .searchbox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .item {
      margin-right: 10px;
      margin-bottom: 14px;
    }
  }
}
</style>
